import * as React from 'react';
import { Price } from '../Price/Price.js';

const Prices = ({ originalPrice , discountedPrice , currency , isCentAmount ,  })=>{
    if (originalPrice && discountedPrice && originalPrice !== discountedPrice) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "v2-product-block-prices"
        }, /*#__PURE__*/ React.createElement(Price, {
            value: discountedPrice,
            currency: currency,
            isCentAmount: isCentAmount,
            type: "new",
            "data-t": "price-discounted",
            size: "small"
        }), /*#__PURE__*/ React.createElement(Price, {
            value: originalPrice,
            currency: currency,
            isCentAmount: isCentAmount,
            type: "old",
            "data-t": "price-original",
            size: "small"
        }));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "v2-product-block-prices"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: originalPrice,
        currency: currency,
        isCentAmount: isCentAmount,
        type: "full",
        "data-t": "price-original",
        size: "small"
    }));
};

export { Prices };
//# sourceMappingURL=Prices.js.map
